import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import {
  ValidUuidOrNotSetSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

import {
  CHECK_RESULT_STOPPER_CHECK,
  CHECK_RESULT_STOPPER_CHECK_RESULT,
  ORDER_BY_STOPPER_RULE,
} from './constants';

export const zodInvoiceStopperRulesQueryParametersSchema = z
  .object({
    buyerCompanyAccountId: ValidUuidOrNotSetSchema,
    buyerCompanyId: ValidUuidOrNotSetSchema,
    isActive: z.boolean().nullish(),
    isGenericStopper: z.boolean().nullish(),
    limit: z
      .number()
      .nonnegative()
      .max(500)
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.number().nonnegative().prefault(0),
    orderBy: z.enum(ORDER_BY_STOPPER_RULE).prefault('created_on'),
    searchString: z.string().trim().nullish(),
    sellerCompanyAccountId: ValidUuidOrNotSetSchema,
    sellerCompanyId: ValidUuidOrNotSetSchema,
    sortOrder: z.enum(PAGINATION_SORT_DIRECTION).prefault('DESC'),
  })
  .transform((data) =>
    withoutObjectKeysWhereValueIs(data, [null, undefined, '']),
  );

export const zodCheckResultStopperCheckSchema = z.enum(
  CHECK_RESULT_STOPPER_CHECK,
);

export const zodCheckResultStopperCheckResultSchema = z.enum(
  CHECK_RESULT_STOPPER_CHECK_RESULT,
);

export const zodCheckResultStopperItemSchema = z.object({
  checkName: zodCheckResultStopperCheckSchema,
  status: zodCheckResultStopperCheckResultSchema,
});

export const zodInvoiceStopperRuleSchema = z.object({
  buyerCompanyAccountId: ValidUuidOrNotSetSchema,
  buyerCompanyAccountName: z.string().nullish(),
  buyerCompanyId: ValidUuidOrNotSetSchema,
  buyerCompanyName: z.string().nullish(),
  createdOn: z.iso.datetime(),
  description: z.string().nullish(),
  id: ValidUuidOrNotSetSchema,
  isActive: z.boolean(),
  isGenericStopper: z.boolean(),
  modifiedOn: z.iso.datetime().nullish(),
  name: z.string().min(1),
  rule: z.object({
    checkResultStopper: z.array(zodCheckResultStopperItemSchema),
    watermarkStopper: z.array(z.string()),
  }),
  sellerCompanyAccountId: ValidUuidOrNotSetSchema,
  sellerCompanyAccountName: z.string().nullish(),
  sellerCompanyId: ValidUuidOrNotSetSchema,
  sellerCompanyName: z.string().nullish(),
});

export const zodInvoiceStopperRulesResponseSchema = z.object({
  data: z.array(zodInvoiceStopperRuleSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().nonnegative(),
  totalCount: z.number().nonnegative(),
});
